import { styled } from '@mui/material/styles';
import { AvatarGroup } from 'shared/mui/AvatarGroup/AvatarGroup';
import { Box } from 'shared/mui/Box';

export const StyledBox = styled(Box)({
  marginBottom: '4px',
  '&:last-child': {
    marginBottom: 0,
  },
});

export const StyledAvatarGroup = styled(AvatarGroup)({
  width: 'fit-content',
  '& .MuiAvatarGroup-avatar': {
    height: 24,
    width: 24,
    fontSize: '11px',
    fontWeight: 500,
  },
});
